import React from 'react';
import { amenitiesData } from '../data/mock';
import { Trees, Crown, Car, UtensilsCrossed, Zap, Users } from 'lucide-react';

const iconMap = {
  Trees: Trees,
  Crown: Crown,
  Car: Car,
  UtensilsCrossed: UtensilsCrossed,
  Zap: Zap,
  Users: Users,
};

const Amenities = () => {
  return (
    <section id="amenities" className="py-20 md:py-28 bg-[#F5F3F0]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="font-sans text-sm text-[#C9A962] tracking-[0.2em] uppercase mb-4 block">
            Our Services
          </span>
          <h2 className="section-title text-3xl md:text-4xl">Amenities & Services</h2>
          <div className="decorative-line" />
          <p className="section-subtitle max-w-2xl mx-auto">
            Everything you need for a flawless celebration, all under one roof
          </p>
        </div>

        {/* Amenities Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {amenitiesData.map((amenity, index) => {
            const IconComponent = iconMap[amenity.icon];
            return (
              <div
                key={amenity.id}
                className="group bg-white rounded-xl p-8 shadow-sm card-hover text-center"
                style={{
                  animationDelay: `${index * 0.1}s`,
                }}
              >
                {/* Icon */}
                <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-gradient-to-br from-[#C9A962]/10 to-[#D4C4B0]/20 flex items-center justify-center group-hover:bg-[#C9A962] transition-colors duration-300">
                  {IconComponent && (
                    <IconComponent
                      size={28}
                      className="text-[#C9A962] group-hover:text-white transition-colors duration-300"
                    />
                  )}
                </div>

                {/* Title */}
                <h3 className="font-serif text-xl text-[#2C2C2C] mb-3">
                  {amenity.title}
                </h3>

                {/* Description */}
                <p className="text-[#6B6259] text-sm leading-relaxed">
                  {amenity.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <p className="text-[#6B6259] mb-6">
            Looking for something specific? We customize packages to match your vision.
          </p>
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="btn-secondary text-sm"
          >
            Request Custom Package
          </a>
        </div>
      </div>
    </section>
  );
};

export default Amenities;
